var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player"},[_c('video-player',{ref:"videoPlayer",staticClass:"vjs-custom-skin",attrs:{"options":_vm.playerOptions},on:{"play":function($event){return _vm.onPlayerPlay($event)},"ready":function($event){return _vm.onPlayerReady($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }